import { render, staticRenderFns } from "./demographicsCard.vue?vue&type=template&id=2922ea3a&scoped=true&lang=html&"
import script from "./demographicsCard.vue?vue&type=script&lang=js&"
export * from "./demographicsCard.vue?vue&type=script&lang=js&"
import style0 from "./demographicsCard.vue?vue&type=style&index=0&id=2922ea3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922ea3a",
  null
  
)

export default component.exports